"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconUiQuoteLeft = function IconUiQuoteLeft(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react.default.createElement("svg", _extends({
    className: (0, _classnames.default)(className, 'svg-icon'),
    viewBox: "0 0 48 48"
  }, props), _react.default.createElement("path", {
    d: "M35.245 22.556a7.894 7.894 0 0 1 5.81 2.4A8.176 8.176 0 0 1 43.52 30.9a7.722 7.722 0 0 1-2.515 5.907 7.681 7.681 0 0 1-5.76 2.437 8.04 8.04 0 0 1-5.891-2.487A7.908 7.908 0 0 1 26.97 30.9v-1.669a32.486 32.486 0 0 1 .166-4.322A20.538 20.538 0 0 1 30.1 15.53a14.617 14.617 0 0 1 7.994-6.325l1.655-.45.91 3.2-1.659.454a11.373 11.373 0 0 0-6.123 5.007 17.071 17.071 0 0 0-2.268 6.542 8.1 8.1 0 0 1 4.636-1.402zm-22.48 0a7.892 7.892 0 0 1 5.809 2.4A8.173 8.173 0 0 1 21.04 30.9a7.722 7.722 0 0 1-2.515 5.907 7.683 7.683 0 0 1-5.76 2.437 8.044 8.044 0 0 1-5.892-2.487A7.907 7.907 0 0 1 4.49 30.9v-1.669a32.318 32.318 0 0 1 .166-4.322 20.538 20.538 0 0 1 2.962-9.379 14.617 14.617 0 0 1 7.994-6.325l1.655-.45.91 3.2-1.655.45a11.37 11.37 0 0 0-6.122 5.011 17.071 17.071 0 0 0-2.268 6.542 8.093 8.093 0 0 1 4.633-1.402z"
  }));
};

IconUiQuoteLeft.propTypes = {
  className: _propTypes.default.string
};
var _default = IconUiQuoteLeft;
exports.default = _default;